import { queryOptions, useQuery } from '@tanstack/react-query';
import { viewQueryKeys } from '@/features/views/queryKeys';
import { ViewApi } from '@/features/visualizations/api/view';

export const getVisualizationViewsQueryOptions = ({ loopId }: { org?: string; loopId: number }) =>
  queryOptions({
    queryKey: viewQueryKeys.visualizationsView.list(loopId),
    queryFn: () => ViewApi.fetchViews(loopId),
    enabled: !!loopId,
  });

export const getVisualizationViewQueryOptions = ({ loopId }: { org?: string; loopId: number }) =>
  queryOptions({
    queryKey: viewQueryKeys.visualizationsView.details(loopId),
    queryFn: async () => {
      const views = await ViewApi.fetchViews(loopId);
      return views.length > 0 ? views[0] : null;
    },
    enabled: !!loopId,
  });

export const useVisualizationViews = (loopId: number) =>
  useQuery(getVisualizationViewsQueryOptions({ loopId }));

export const useVisualizationView = (loopId: number) => {
  return useQuery({
    ...getVisualizationViewQueryOptions({ loopId }),
    enabled: !!loopId,
  });
};
